import type { FunctionComponent } from 'preact';
import { useEffect, useState } from 'preact/hooks';

import { dialogOpened } from 'Core/actions/dialog';
import { usePopup } from 'Core/hooks/index';
import { useDispatch } from 'Core/store';

import AutoSyncVisualization, { type Props as AutoSyncVisualizationProps } from './autoSyncVisualization';

const DialogName = 'AutoSyncVisualizationDialog';

const AutoSyncVisualizationDialog: FunctionComponent<AutoSyncVisualizationProps> = ({ template, config }) => {
  const dispatch = useDispatch();
  const [wheelMpn, setWheelMpn] = useState<string>();
  const { opened, close } = usePopup(DialogName);

  useEffect(() => {
    window.Convermax.openVisualizationDialog = (wheelMpn: string) => {
      setWheelMpn(wheelMpn);
      dispatch(dialogOpened(DialogName));
    };
  }, [dispatch]);

  if (!opened) {
    return null;
  }

  const visualizationProps = {
    template,
    config: {
      height: window.innerWidth > 1024 ? 'calc(80vh - 80px)' : 'calc(100vh - 80px)',
      vehicleImageSize: 2400,
      widthAdjustment: 'scale',
      showColorPicker: true,
      vehicleAngles: [1, 32, 14], // used to add scrollabled images
      ...(config ?? {}),
    },
    wheelMpn,
    toggleGridButtonVisibility: false,
    extraParams: {
      close,
    },
  } satisfies AutoSyncVisualizationProps;

  return <AutoSyncVisualization {...visualizationProps} />;
};

export default AutoSyncVisualizationDialog;
